import { BaseComponent } from './../base/base.component';
import { Component, AfterViewInit, ApplicationInitStatus, OnInit, AfterContentInit } from '@angular/core';
import * as $ from 'jquery';
declare var window:any;
@Component({
    selector: 'home',
    template: require('./home.component.html')
})
export class HomeComponent extends BaseComponent implements OnInit, AfterContentInit {

    public dashboardData = {
        organizationsCount:0,
        distributedSurveysCount:0,
        questionsCount:0,
        responsesCount:0,
        distributedSurveys7Days:[],
        distributedSurveysCompleted7Days:[],
        last4DistributedSurveys:[],
        recent10Activites: []
    };

    ngOnInit() {
        this.loginRequired();
    }

    ngAfterContentInit(){
       
    console.log("Start");

    this.loadDashboardData();
    
    console.log("Done");
  }

  public loadDashboardData() {
    this.busy = this.lsApi.getDashboardData().subscribe(resp => {
        if(resp.status) {
            this.dashboardData = resp.data[0];

            window.distributedSurveyLabel = "Distributed Survey(s)";
            window.completedSurveyLabel = "Completed Survey(s)";

            window.distributedSurveyLabels = [];
            window.distributedSurveyData = [];
            
            for(var i=0;i<this.dashboardData.distributedSurveys7Days.length;i++) {
                var s = this.dashboardData.distributedSurveys7Days[i];
                var label = s.groupLabel.d + "/" + s.groupLabel.m + "/" + s.groupLabel.y;
                var data = s.groupCount;
                window.distributedSurveyLabels.push(label);
                window.distributedSurveyData.push(data);
            }

            if(window.distributedSurveyData.length<7) {
                var x = (7-window.distributedSurveyData.length)
                for(var i=0;i<x;i++) {
                    window.distributedSurveyLabels.push("N/A");
                    window.distributedSurveyData.push(0);
                }
            }

            window.completedSurveyLabels = [];
            window.completedSurveyData = [];
            
            for(var i=0;i<this.dashboardData.distributedSurveysCompleted7Days.length;i++) {
                var s = this.dashboardData.distributedSurveysCompleted7Days[i];
                var label = s.groupLabel.d + "/" + s.groupLabel.m + "/" + s.groupLabel.y;
                var data = s.groupCount;
                window.completedSurveyLabels.push(label);
                window.completedSurveyData.push(data);
            }

            if(window.completedSurveyData.length<7) {
                var x = (7-window.completedSurveyData.length)
                for(var i=0;i<x;i++) {
                    window.completedSurveyLabels.push("N/A");
                    window.completedSurveyData.push(0);
                }
            }
            
            setTimeout(()=>{    //<<<---    using ()=> syntax
                $.getScript('/static/assets/be/app/js/dashboard.js');
            },1000);

        }
    },
    error => {
        console.log(error);
    });
  }


  public surveyPercentage(s) {
    var perct = 0;
    perct = s.employeeCompletedCount / s.employeeCount * 100;
    return perct;
  }
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/home/home.component.ts